import { render, staticRenderFns } from "./details.component.vue?vue&type=template&id=38f1751c&scoped=true"
import script from "./details.component.vue?vue&type=script&lang=js"
export * from "./details.component.vue?vue&type=script&lang=js"
import style0 from "./details.component.vue?vue&type=style&index=0&id=38f1751c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1751c",
  null
  
)

export default component.exports